import { Product, ProductCountry, ProductShipment } from '@app/models';

let productData: { [n: string]: any } = {};
let productDatas = [];

let productMetadata: { [n: string]: any } = {};
let productMetadatas = [];

let productCountryData: { [n: string]: any } = {};
let productCountryDatas = [];

let productCountryMetadata: { [n: string]: any } = {};
let productCountryMetadatas = [];

let productCountryShipmentData: { [n: string]: any } = {};
let productCountryShipmentDatas = [];

let productCountryShipmentMetadata: { [n: string]: any } = {};
let productCountryShipmentMetadatas = [];

let set = [];

let objectSetting: {
  value: number;
  name: string;
  CountryId: number;
  businessUnit: number;
  type: string;
}[] = [];

let objectSettings = [];

export const isUnique = (data: any, arrayData: any) => {
  const dataRed = arrayData.reduce((acc, p) => {
    acc[Object.keys(p)[0]] = p;

    return acc;
  }, {});

  return dataRed[Object.keys(data)[0]];
};

export const setPush = (data: any, type: any) => {
  let num = 0;
  const filt = set.find(x => x.ProductIds + 0 === data.ProductIds + 0) || 0;
  if (filt) {
    set.map(x => {
      // console.log(Number(x.ProductIds), Number(data.ProductIds), x.metadata.cbmPerCarton, type);
      if (
        x.ProductIds + 0 === data.ProductIds + 0 &&
        x.metadata.master &&
        type !== 'pvp' &&
        type !== 'Cbm'
      ) {
        x.metadata = data.metadata;
        num = 1;
        // console.log('Existe master');
        return 0;
      }
      if (
        x.ProductIds + 0 === data.ProductIds + 0 &&
        x.metadata.pvp &&
        type !== 'master' &&
        type !== 'Cbm'
      ) {
        x.metadata = data.metadata;
        num = 1;
        // console.log('Existe pvp');
        return 0;
      }
      if (
        x.ProductIds + 0 === data.ProductIds + 0 &&
        x.metadata.cbmPerCarton &&
        type !== 'master' &&
        type !== 'pvp'
      ) {
        x.metadata = data.metadata;
        num = 1;
        // console.log('Existe Cbm');
        return 0;
      }
    });
  }
  if (num === 1) {
    return 0;
  }
  // console.log('No existe');
  set.push(data);
  return 1;
};

export const setSav = () => {
  // console.log('SET TO SAVE', set);
  return set;
};

export const objt = (data: any) => {
  // console.log(data);
  const filt =
    objectSettings.find(
      x =>
        // x.value === data.value &&
        x.type === data.type &&
        x.CountryId === data.CountryId &&
        x.businessUnit === data.businessUnit &&
        x.name === data.name
    ) || 0;
  // console.log('Filter', filt);
  if (filt) {
    objectSettings.map(x => {
      if (
        x.type === data.type &&
        x.CountryId === data.CountryId &&
        x.businessUnit === data.businessUnit &&
        x.name === data.name
      ) {
        x.value = data.value;
        data = x;
        // console.log('New Data', data);
      }
    });
    // console.log('Existe');
    objectSetting = objectSettings;
    return 0;
  }
  if (filt === 0) {
    objectSettings.push(data);
  }
  objectSetting = objectSettings;

  return 1;
};

export const getObjectSettings = () => {
  return objectSettings;
};

export const clearObjectSettings = () => {
  return (objectSettings = []);
};

export const clearSet = () => {
  return (set = []);
};

// export const unique = (data: any, type: any) => {
//   switch (type) {
//     case 'Product':

//       return isUnique;

//       break;

//     case 'ProductMetadata':
//       const productMetadataRed = productMetadatas.reduce((acc, p) => {
//         acc[Object.keys(p)[0]] = p;

//         return acc;
//       }, {});

//       return productMetadataRed[Object.keys(data)[0]];

//       break;

//     case 'ProductCountry':
//       break;

//     case 'ProductCountryMetadata':
//       break;

//     case 'ProductCountryShipment':
//       break;

//     case 'ProductCountryShipmentMetadata':
//       break;
//   }
// };

// export const uniqueMetadata = (data: any) => {

// };

export const saveData = (
  data: any,
  arrayData: any,
  objectData: any,
  type: any
) => {
  if (!isUnique(data, arrayData)) {
    arrayData.push(data);
  } else {
    const index = arrayData.findIndex(
      x => Object.keys(x)[0] === Object.keys(data)[0]
    );

    arrayData[index] = data;
  }

  for (const NewData of arrayData) {
    objectData[Object.keys(NewData)[0]] = Object.values(NewData)[0];
  }

  return objectData;
};

export const saveFactor = (data: any, type: any) => {
  switch (type) {
    case 'Factor':
      return saveData(data, objectSetting, objectSettings, type);
  }
};

export const saveChangesMeta = (data: any, type: any, id: any) => {
  for (let i = 0; i < productCountryMetadatas.length; i = i + 2) {
    if (productCountryMetadatas[i][0] === id[0]) {
      // console.log('Ya existe', id[0]);
      productCountryMetadatas[i + 1] = data;
      return 0;
    }
  }
  productCountryMetadatas.push(id, data);
  return 1;
};

export const getProCoun = () => {
  return productCountryMetadatas;
};

export const clearProCoun = () => {
  return (productCountryMetadatas = []);
};

export const saveChanges = (data: any, type: any) => {
  switch (type) {
    case 'Product':
      return saveData(data, productDatas, productData, type);

      break;

    case 'ProductMetadata':
      return saveData(data, productMetadatas, productMetadata, type);

      break;

    case 'ProductCountry':
      return saveData(data, productCountryDatas, productCountryData, type);
      break;

    case 'ProductCountryMetadata':
      return saveData(
        data,
        productCountryMetadatas,
        productCountryMetadata,
        type
      );
      break;

    case 'ProductCountryShipment':
      break;

    case 'ProductCountryShipmentMetadata':
      break;
  }
};

export const saveButton = (data: any, type: any) => {
  // if (!isUnique(data, type)) {
  //   return true;
  // } else {
  //   return false;
  // }
  switch (type) {
    case 'Product':
      return !isUnique(data, productDatas);

      break;

    case 'ProductMetadata':
      return !isUnique(data, productMetadatas);

      break;

    case 'ProductCountry':
      return !isUnique(data, productCountryDatas);
      break;

    case 'ProductCountryMetadata':
      return !isUnique(data, productCountryMetadatas);
      break;

    case 'ProductCountryShipment':
      break;

    case 'ProductCountryShipmentMetadata':
      break;
  }
};

// export const saveButtonMetadata = (data: any) => {
//   if (!uniqueMetadata(data)) {
//     return true;
//   } else {
//     return false;
//   }
// };

export const clearChange = () => {
  productDatas = [];
  productData = {};
  productMetadatas = [];
  productMetadata = {};

  productCountryData = {};
  productCountryDatas = [];
  productCountryMetadata = {};
  productCountryMetadatas = [];

  productCountryShipmentData = {};
  productCountryShipmentDatas = [];
  productCountryShipmentMetadata = {};
  productCountryShipmentMetadatas = [];
};
